module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-projects",
    attrs: {
      "id": "projects"
    }
  }, [_c('ul', {
    staticClass: "projects-showcase clearfix"
  }, [_c('li', [_c('figure', {
    staticClass: "project-photo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/1.jpg"),
      "alt": "Korean bibimbap with egg and vegetables"
    }
  })])]), _vm._v(" "), _c('li', [_c('figure', {
    staticClass: "project-photo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/2.jpg"),
      "alt": "Simple italian pizza with cherry tomatoes"
    }
  })])]), _vm._v(" "), _c('li', [_c('figure', {
    staticClass: "project-photo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/3.jpg"),
      "alt": "Chicken breast steak with vegetables"
    }
  })])]), _vm._v(" "), _c('li', [_c('figure', {
    staticClass: "project-photo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/4.jpg"),
      "alt": "Autumn pumpkin soup"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "projects-showcase clearfix"
  }, [_c('li', [_c('figure', {
    staticClass: "project-photo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/5.jpg"),
      "alt": "Paleo beef steak with vegetables"
    }
  })])]), _vm._v(" "), _c('li', [_c('figure', {
    staticClass: "project-photo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/6.jpg"),
      "alt": "Healthy baguette with egg and vegetables"
    }
  })])]), _vm._v(" "), _c('li', [_c('figure', {
    staticClass: "project-photo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/7.jpg"),
      "alt": "Burger with cheddar and bacon"
    }
  })])]), _vm._v(" "), _c('li', [_c('figure', {
    staticClass: "project-photo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/8.jpg"),
      "alt": "Granola with cherries and strawberries"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2bff9406"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Projects.vue
// module id = 99
// module chunks = 0